import React from 'react';
import { Col } from '../../../lib/utils';
import { Body2Bold, Body3Regular } from '../../../lib/font';
import { colors } from '../../../lib/colors';

interface PaymentStateScreenProps {
    title: string;
    description?: string;
    isError?: boolean;
}

const PaymentStateScreen: React.FC<PaymentStateScreenProps> = ({ title, description, isError = false }) => (
    <Col
        style={{
            width: '100%',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#F5F7FA',
            padding: 16,
        }}
    >
        <Col
            style={{
                width: '100%',
                maxWidth: 480,
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '32px 24px',
                alignItems: 'center',
                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            }}
        >
            <Body2Bold style={{ color: isError ? colors.ERROR : colors.LAVEL_4 }}>{title}</Body2Bold>
            {description && (
                <Body3Regular style={{ color: colors.LAVEL_2, marginTop: 8, textAlign: 'center' }}>
                    {description}
                </Body3Regular>
            )}
        </Col>
    </Col>
);

export default PaymentStateScreen;
